import { useEffect, useState } from "react";
import config from "../../config";
import app from "../../components/app";

const fetchPost = async function(data, mode) { 
    if(!mode) {
      app.preloader(true);
    }
    data["project"] = "divkit";
    let response = await fetch(app.config().postURL, {
      // body:JSON.stringify({
      //     payload:cryptography.encrypt2(JSON.stringify(data))
      // }),
      body:JSON.stringify(data),
      method: "POST",
      // headers:{
      //   'Content-Type': 'application/json'
      // }
    });
    response = await response.json();
    //response = JSON.parse(cryptography.decrypt2(response.data));
    
    console.log(data, response);

    if(!mode) {
      app.preloader(false);
    }
    return response;
}

const Modal = function(props){
    
    return <div className={`modal ${props.mode?"show d-block":""}`} style={{background:"rgba(0,0,0,0.4)"}}>
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{props.title}</h5>
            <button type="button" className="btn-close modal-close close-popup" onClick={() => props.close()}></button>
          </div>
          <div className="modal-body">
            {props.children}
          </div>
        </div>
      </div>
    </div>
}



const BlockForm = function({data, id, index, callback}){
    const [item, setItem] = useState(data?data:app.defaultData("blockKeys"));
    console.log(item);
    const saveBlock = function(){
        if(item["name"] === "") {
            alert("Enter valid page name!");
            return false;
        }
        if(item["key"] === "") {
            alert("Enter valid page KEY!");
            return false;
        }
        if(!item.data) {
            item.data = JSON.stringify({
              webHtml:"",
              webJson:{
  "card": {
    "log_id": "divkit_web_card",
    "states": [
      {
        "state_id": 0,
        "div": {
          "type": "container",
          "items": [],
          "width": {
            "type": "match_parent"
          },
          "height": {
            "type": "wrap_content"
          },
          "paddings": {
            "left": 0,
            "right": 0,
            "top": 0,
            "bottom": 0
          },
          "background": [
            {
              "type": "solid",
              "color": "#FFFFFF"
            }
          ]
        }
      }
    ]
  },
  "templates": {}
},
"mobileJson":{
  "card": {
    "log_id": "divkit_mobile_card",
    "states": [
      {
        "state_id": 0,
        "div": {
          "type": "container",
          "width": {
            "type": "match_parent"
          },
          "items": [],
          "height": {
            "type": "wrap_content"
          },
          "paddings": {
            "left": 0,
            "right": 0,
            "top": 0,
            "bottom":0
          },
          "background": [
            {
              "type": "solid",
              "color": "#FFFFFF"
            }
          ]
        }
      }
    ]
  },
  "templates": {}
}
        }

            )
        }
        console.log(item);
        fetchPost({
            ...item,
            "method":item.id?"update":"insert"
        }).then(function(response){
            console.log(response);
            if(response.success) {
                alert("Page information successfully saved and updated!");
                if(callback) {
                    callback(response.data, index);
                    document.querySelector("#" + id).remove();
                }
            }
            else {
                alert(response.error);
                document.querySelector("#" + id).remove();
            }
        })
   }
    const handleChange = (e) => {
    const { id, value, type, checked } = e.target;
    if(id === "status") {
      setItem({
        ...item,
        status: e.target.getAttribute("data-value") === "1"?1:0,
      });
    }
    else {
      setItem({
        ...item,
        [id]: type === 'checkbox' ? checked : value,
      });
    }
  };

  
    
    return <div className={`w-100`}>
      {
                    config.blockKeys.map(function(v){
                      let input = <input type="text" id={v.key} className="form-control" value={item[v.key]} onChange={handleChange} placeholder={v.placeholder} />
                      if(v.type === "textarea") {
                        input = <textarea className="form-control" id={v.key} placeholder={v.placeholder.toString()} value={item[v.key]} onChange={handleChange} />
                      }
                      if(v.type === "select") {
                        input = <select className="form-control" id={v.key} value={item[v.key]} onChange={handleChange}>
                          {
                            v.options.map(function(val){
                              return  <option value={val.value}>{val.text}</option>
                            })
                          }
                         
                        </select>
                      }
                      if(v.type === "tabs") {
                        input =  <div className="btn-group">
                          {
                            v.options.map(function(val){
                              let active = "";
                              if(val.value === item[v.key]) {
                                active = "active";
                              }
                              return <button type="button" id={v.key} onClick={handleChange} data-value={val.value} className={`btn btn-outline-primary ${active}`}>{val.text}</button>
                            })
                          }
                        </div>
                      }
                     
                      return  <div className={`mb-3 ${v.type === "textarea"?"":"d-flex"} ${v.type === "hidden"?"d-none":""}`} key={v.key}>
                        <label className="form-label w-25">{v.text}</label>
                        <div className={`${v.type === "textarea"?"w-100":"w-75"}`}>{input}</div>
                      </div>
                    })
                  }

                    <div className="modal-footer">
        <button type="button" className="btn btn-primary" onClick={saveBlock}>Save</button>
      </div>
    </div>
}



export default function(){
     const [data, setData] = useState([]);
     const [item, setItem] = useState(null);
     const [index, setIndex] = useState(null);
    useEffect(() => {
        fetchPost({
            "method":"getAll"
            //"method":"getActive"
        }).then(function(response){
            if(response.data) {
                setData(response.data.results);
            }
        })
    }, []);

    const updateData = function(item, index){
        if(index === undefined) {
            setData([item, ...data]);
        }
        else {
            setData(data.map(function(v, i){
                if(i === index) {
                    return item;
                }
                return v;
            }));
        }
    }

    const deleteItem = function(index) {
        if(window.confirm("do you really want to delete this Block")) {
            fetchPost({
                "method":"delete",
                "id":data[index].id
            }).then(function(){
                setData(data.filter(function(v, i){
                    if(i === index) {
                        return false;
                    }
                    return true;
                }))
            })
        }
    }

    // "clone open": first fetch the block by id to get all its data/text fields,
    // then open the form prefilled so it can be reviewed and saved as a new block.
    const cloneOpen = function(index) {
        const popupId = "block-popup";
        fetchPost({
            "method":"get",
            "id":data[index].id
        }).then(function(response){
            if(!response.success || !response.data) {
                alert(response.error || "Unable to load block to clone");
                return;
            }
            const source = response.data;
            const clone = {
                ...source,
                "name":`${source.name} Copy`,
                "key":`${source.key}-copy`
            };
            delete clone.id;
            // no id => BlockForm "Save" will insert it as a new block
            app.createPopup(<BlockForm data={clone} callback={updateData} id={popupId} />, popupId);
        });
    }

    const cloneBlock = function(index) {
        // server-side one-call clone — commented for timing (backend method not ready yet)
        // if(!window.confirm("do you really want to clone this Block")) return;
        // fetchPost({ "method":"cloneBlock", "id":data[index].id }).then(function(res){
        //     if(res.success) { alert("Block successfully cloned!"); updateData(res.data); }
        //     else alert(res.error);
        // });
    }

    const editItem = function(index) {
      const popupId = "block-popup";
      if(index === undefined) {
        app.createPopup(<BlockForm callback={updateData} id={popupId} />, popupId);
      }
      else {
        fetchPost({
            "method":"get",
            "id":data[index].id
        }).then(function(response){
           app.createPopup(<BlockForm index={index} data={response.data} callback={updateData} id={popupId} />, popupId);
        })
      }
      
        //     fetchPost({
        //         "method":"delete",
        //         "id":data[index].id
        //     }).then(function(){
        //         setData(data.filter(function(v, i){
        //             if(i === index) {
        //                 return false;
        //             }
        //             return true;
        //         }))
        //     })
        // }
    }

    
    let modalItem = null;
    if(item) {
        if(item === "add") {
            modalItem = <BlockForm callback={updateData} />
        }
        else {
            modalItem = <BlockForm data={item} callback={updateData} />
        }
    }
   
    return <div className="container-fluid p-0" style={{height:"100%", overflow:"scroll"}}>
    <div className="container p-0">
        <div className="w-100">
            <h2 className="p-0 mt-3">Blocks <button className="btn btn-primary float-end" onClick={() => editItem()}>add block</button></h2>
            
        </div>
  <div className="row align-items-start">
    {
        data.map(function(v, i){
            return  <div key={`${v.id}`} className="col-3 pt-4">
                <div className="card" >
  <img src="/images/image-2x1.png" style={{backgroundImage:`url(https://custom-images.mediadirhub.com/divkit/blocks/desktop-${v.id}.png?version=${Date.now()})`, backgroundSize:"100%", backgroundRepeat:"no-repeat"}} className="card-img-top" alt="" />
  <div className="card-body">
  <h5 className="card-title">{v.name}</h5>
  <p className="card-text">
    <span className="badge bg-secondary me-2">{v.page}</span>
    <span className="badge bg-secondary">{v.type}</span>
  </p>
  
</div>
 <div className="card-footer">
  
  <button  className="btn btn-sm btn-danger me-2" onClick={() => deleteItem(i)}>delete</button>
   <button  className="btn btn-sm btn-secondary me-2" onClick={() => cloneBlock(i)}>clone</button>
   <button  className="btn btn-sm btn-secondary me-2" onClick={() => cloneOpen(i)}>clone open</button>
   <a href={`/blocks/${v.id}/preview`} className="btn btn-sm btn-primary me-2">preview</a>
   <button  className="btn btn-sm btn-primary me-2" onClick={function(){
   
    editItem(i);
   }}>edit Info</button>
   <a href={`/appkit-editor?blockId=${v.id}`} className="btn btn-sm btn-primary">edit</a>
  </div>

</div>
            </div>
        })
    }
  </div>
</div>
{/* {createPortal(
    <Modal title="Ravi Kumar" mode={modalItem?true:false} close={setItem}>{modalItem}</Modal>,
    document.body
  )} */}
</div>

}